export default theme => ({
  title: {
    display: "block",
    width: "100%",
    textAlign: "center",
  },
  period: {
    display: "block",
    marginTop: 25,
  },
  timeline: {
    width: "100%",
  },
});
